<div class="login-container position-absolute h-100 w-100 top-0 m-auto" [ngClass]="{'login-container-light': tema === 'Light', 'login-container-dark': tema === 'Dark'}">
    <div class="row container m-auto align-content-center login-content h-100">
        <div class="col-12 col-lg-4 pb-lg-5">
            <div class="left-column d-block d-lg-flex flex-column align-items-end justify-content-center align-items-lg-center justify-content-lg-center w-100 h-100">
                <div class="login-logo mx-auto text-center mb-4">
                    <img src="../../../assets/img/general/logo_milvus.svg" alt="Milvus">
                </div>
                <div class="login-card bg-white"  *ngIf="isValid; else other_content">
                    <h2 class="title-login" style="font-weight: bolder;">
                        <strong [translate]="'ENTRAR_NO_MILVUS'"></strong>
                    </h2>
                    <form [formGroup]="loginForm" (ngSubmit)="login()">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="login-input-icon">
                                    <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M27 1.50402e-07C27.7569 -0.000239369 28.4858 0.28561 29.0408 0.800245C29.5958 1.31488 29.9357 2.02027 29.9925 2.775L30 3V21C30.0002 21.7569 29.7144 22.4858 29.1998 23.0408C28.6851 23.5958 27.9797 23.9357 27.225 23.9925L27 24H3C2.24314 24.0002 1.51415 23.7144 0.959178 23.1998C0.404206 22.6851 0.0642651 21.9797 0.00750032 21.225L1.50402e-07 21V3C-0.000239369 2.24314 0.28561 1.51415 0.800245 0.959178C1.31488 0.404206 2.02027 0.0642651 2.775 0.00750032L3 1.50402e-07H27ZM27 5.121L16.59 15.531C16.1681 15.9524 15.5963 16.189 15 16.189C14.4037 16.189 13.8319 15.9524 13.41 15.531L3 5.121V21H27V5.121ZM24.879 3H5.121L15 12.879L24.879 3Z" fill="#0073E9"/>
                                        </svg>
                                </span>
                            </div>
                            <input #email type="email" class="login-input form-control login-input" placeholder="Email"
                                type="email" (focus)="focus = true" autocompleteOff (blur)="focus = false" formControlName="email"
                                [ngClass]="{'campo-invalido-login': errorMessage && (!loginForm.value.email || loginForm.get('email').invalid)}">
                        </div>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="login-input-icon">
                                    <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 6.4756e-09C16.4148 -9.11634e-05 18.7357 0.962506 20.475 2.68554C22.2142 4.40858 23.2366 6.75794 23.3271 9.24L23.3333 9.6H24.8889C25.6738 9.59974 26.4298 9.90465 27.0053 10.4536C27.5808 11.0025 27.9334 11.755 27.9922 12.56L28 12.8V28.8C28.0002 29.6073 27.7038 30.3849 27.1701 30.9769C26.6364 31.5688 25.9049 31.9315 25.1222 31.992L24.8889 32H3.11111C2.32621 32.0003 1.57023 31.6954 0.994703 31.1464C0.419177 30.5975 0.0666453 29.845 0.00777811 29.04L1.55972e-07 28.8V12.8C-0.000248234 11.9927 0.296188 11.2151 0.829884 10.6231C1.36358 10.0312 2.09509 9.66855 2.87778 9.608L3.11111 9.6H4.66667C4.66667 7.05392 5.65 4.61212 7.40034 2.81177C9.15068 1.01143 11.5246 6.4756e-09 14 6.4756e-09ZM24.8889 12.8H3.11111V28.8H24.8889V12.8ZM14 16C14.6636 16.0002 15.3097 16.2187 15.844 16.6234C16.3783 17.0282 16.7728 17.5981 16.9698 18.2499C17.1669 18.9016 17.1561 19.6011 16.9392 20.2462C16.7222 20.8912 16.3105 21.448 15.764 21.8352L15.5556 21.9712V24C15.5551 24.4078 15.4033 24.8001 15.1311 25.0966C14.859 25.3931 14.487 25.5716 14.0912 25.5955C13.6954 25.6194 13.3056 25.4869 13.0016 25.2252C12.6976 24.9634 12.5022 24.5922 12.4553 24.1872L12.4444 24V21.9712C11.8514 21.619 11.3879 21.0753 11.1258 20.4245C10.8638 19.7737 10.8178 19.0522 10.995 18.3718C11.1723 17.6914 11.5629 17.0901 12.1062 16.6613C12.6495 16.2325 13.3152 16 14 16ZM14 3.2C12.3498 3.2 10.7671 3.87428 9.60022 5.07452C8.43333 6.27475 7.77778 7.90261 7.77778 9.6H20.2222C20.2222 7.90261 19.5667 6.27475 18.3998 5.07452C17.2329 3.87428 15.6502 3.2 14 3.2Z" fill="#0073E9"/>
                                        </svg>                                            
                                </span>
                            </div>
                            <input #senha placeholder="{{ 'SENHA' | translate }}" type="password" autocompleteOff class="login-input form-control login-input" 
                                (focus)="focus1 = true" (blur)="focus1 = false" formControlName="senha"
                                [ngClass]="{'campo-invalido-login': errorMessage && !loginForm.value.senha}">
                        </div>
                    
                        <div class="form-group" *ngIf="errorMessage !== null">
                            <div class="col-12">
                                <small class="text-danger">{{ errorMessage }}</small>
                            </div>
                        </div>
                        <div class="login-info my-3">
                            <a class="login-info" [ngClass]="{'light-link': tema === 'Dark'}" (click)="openModal()" [translate]="'ESQUECEU_SENHA'">
                            </a>
                        </div>
                        <div class="text-center mb-3" container="body" ngbTooltip="{{ 'TOOLTIP_LOGIN' | translate }}"
                            [disableTooltip]="!loginForm.invalid" tooltipClass="custom-bottom-tooltip">
                            <button [disabled]="submitted" class="btn btn-login w-100 p-3" type="submit"  [translate]="'ENTRAR'"></button>
                        </div>
                        <div class="d-flex justify-content-around">
                            <div>
                                <a class="login-info"  [ngClass]="{'light-link': tema === 'Dark'}" href="https://milvus.com.br/politica" target="_blank" [translate]="'TERMOS_PRIVACIDADE'">
                                </a>
                            </div>
                        
                            <div class="mr-1 dropdown" dropdown>
                                <a [ngClass]="{'drop-light': tema === 'Light', 'text-light': tema === 'Dark'}" class="dropdown-toggle" href="javascript:void(0)" id="dropdownMenuButton" dropdownToggle style="text-decoration: underline;">
                                <small>{{ translate.currentLang | translate }}</small>
                                </a>
                                <div  aria-labelledby="dropdownMenuButton" *dropdownMenu class="dropdown-menu">
                                <a *ngFor="let lang of translate.getLangs()" (click)="translate.use(lang)" class="dropdown-item login-info" href="javascript:void(0)">{{lang | translate}}</a>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <ng-template #other_content>
                    <ng-container *ngIf="!isMultiSessao; else multisessaoAviso">
                        <div class="login-card bg-white">
                            <div class="bg-transparent pb-3 border-0 title" style="font-size: 20px; text-align: center;">
                                <span [translate]="'CODIGO_AUTENTICACAO_2FA'"></span>
                            </div>
                            <div>
                                <div class="pb-3">
                                    <span style="font-size: 13px;">
                                        {{ "DIGITE_CODIGO_ENVIADO_EMAIL_COFRE_SENHAS" | translate }} <br>
                                        {{ "DIGITE_CODIGO_ENVIADO_EMAIL_COFRE_SENHAS_EMAIL" | translate : { email: email_codificado} }} <br>
                                        {{ "POR_FAVOR_VERIFIQUE_EMAIL" | translate }}
                                    </span>
                                </div>
                                <form [formGroup]="codigoForm" class="pb-1">
                                    <div class="d-flex gap-3 justify-content-around mx-auto" style="max-width: 540px;">
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_primeiro"
                                            id="validacao_primeiro"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab('validacao_primeiro', 'validacao_segundo', {event: $event, field: null});"
                                        >
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_segundo"
                                            id="validacao_segundo"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab('validacao_segundo', 'validacao_terceiro', {event: $event, field: 'validacao_primeiro'});"
                                        >
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_terceiro"
                                            id="validacao_terceiro"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab('validacao_terceiro', 'validacao_quarto', {event: $event, field: 'validacao_segundo'});"
                                        >
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_quarto"
                                            id="validacao_quarto"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab('validacao_quarto', 'validacao_quinto', {event: $event, field: 'validacao_terceiro'});"
                                        >
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_quinto"
                                            id="validacao_quinto"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab('validacao_quinto', 'validacao_sexto', {event: $event, field: 'validacao_quarto'});"
                                        >
                                        <input
                                            type="text" 
                                            class="form-control col-custom padding-cell" 
                                            maxlength="1" 
                                            minlength="1"
                                            formControlName="validacao_sexto"
                                            id="validacao_sexto"
                                            onkeypress="return (event.charCode !=8 && event.charCode == 0 || (event.charCode >= 48 && event.charCode <= 57))"
                                            (keyup)="autoTab(null, null, {event: $event, field: 'validacao_quinto'});"
                                        >
                                    </div>
                                    <div *ngIf="mostraLembrarDispositivo" class="row mt-4">
                                        <div class="col-12 form-group mb-0">
                                            <div class=" custom-control custom-checkbox">
                                                <input class=" custom-control-input" id="customCheckDispositivo" formControlName="lembrar"
                                                    (click)="rememberThisDevice($event)" type="checkbox">
                                                <label 
                                                    class="custom-control-label" 
                                                    for="customCheckDispositivo" 
                                                    style="padding-top: 3px; ">{{'DISPOSITIVO_CONFIAVEL' | translate}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="col-12 text-center pb-3 pt-3">
                                    <button class="btn btn-darkblue btn-md badge-pill w-100"
                                      (click)="confirmCode()" [disabled]="codigoForm.invalid"
                                      >
                                        <span [translate]="'ENTRAR'"></span>
                                    </button>
                                </div>
                                <hr class="my-1" style="border-top: 1px solid gray;">
                                <div class=" row mt-3">
                                    <div class=" col-6">
                                        <a class="text-light" href="javascript:void(0)" (click)="resendCode()">
                                            <small [translate]="'REENVIAR_CODIGO'"></small>
                                        </a>
                                    </div>
                
                                    <div class=" col-6 text-right">
                                        <div class="mr-1 dropdown" dropdown>
                                            <a class="text-light dropdown-toggle" href="javascript:void(0)" id="dropdownMenuButton" dropdownToggle>
                                            <small>{{ translate.currentLang | translate }}</small>
                                            </a>
                                            <div  aria-labelledby="dropdownMenuButton" *dropdownMenu class="dropdown-menu">
                                            <a *ngFor="let lang of translate.getLangs()" (click)="translate.use(lang)" class="dropdown-item" href="javascript:void(0)">{{lang | translate}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #multisessaoAviso>
                        <div class="login-card bg-white">
                            <h2 class="title-login" style="font-weight: bolder;">
                                <strong [translate]="'ENTRAR_NO_MILVUS'"></strong>
                            </h2>
                            <div class="d-flex mb-4 mt-4 text-danger" style="font-weight: bolder;">
                                <i class="fa-light fa-shield-exclamation mr-2" style="font-size: 106px"></i>
                                <span [translate]="'MSG_MULTISESSAO'"></span>
                            </div>
                            <div class="text-center mb-3">
                                <button class="btn btn-login w-100 p-3" (click)="encerraSessoes(isMultiSessao)" type="button" [translate]="'ENTRAR'"></button>
                            </div>
                            <div class="d-flex justify-content-around">
                                <div>
                                    <a class="login-info"  [ngClass]="{'light-link': tema === 'Dark'}" href="https://milvus.com.br/politica" target="_blank" [translate]="'TERMOS_PRIVACIDADE'">
                                    </a>
                                </div>
                            
                                <div class="mr-1 dropdown" dropdown>
                                    <a [ngClass]="{'drop-light': tema === 'Light', 'text-light': tema === 'Dark'}" class="dropdown-toggle" href="javascript:void(0)" id="dropdownMenuButton" dropdownToggle style="text-decoration: underline;">
                                    <small>{{ translate.currentLang | translate }}</small>
                                    </a>
                                    <div  aria-labelledby="dropdownMenuButton" *dropdownMenu class="dropdown-menu">
                                    <a *ngFor="let lang of translate.getLangs()" (click)="translate.use(lang)" class="dropdown-item login-info" href="javascript:void(0)">{{lang | translate}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-template>
            </div>
        </div>
        <div class="col-12 col-lg-4 pb-lg-5">
            <div class="chamada-col chamada-col-md position-relative d-none d-md-flex flex-column align-items-center justify-content-center w-100 h-100">
                <div class="login-text p-2">
                    <h2 #slogan class="title-login" style="font-size: 2.4rem;" >
                    </h2>
                    <div [translate]="'CHAMADA_LOGIN'" style="font-size: 14px;"></div>
                    <div class="w-full">
                        <a class="w-100 text-center p-3" [ngClass]="{'btn-contact-light': tema === 'Light', 'btn-contact-dark': tema === 'Dark'}" href="https://api.whatsapp.com/send?phone=+551151999219&text=Oi&source=&data=&app_absent=" target="_blank">
                            <strong [translate]="'FALAR_TIME_COMERCIAL'"></strong>
                        </a>
                    </div>
                </div>
            </div>
            <div class="chamada-col position-relative d-flex d-md-none flex-column align-items-center text-center justify-content-center w-100 h-100">
                <div class="login-text p-2">
                    <h2 class="title-login" [translate]="'SLOGAN_LOGIN'">
                    </h2>
                    <div [translate]="'CHAMADA_LOGIN'" style="font-size: 14px;"></div>
                    <div class="w-full">
                        <a class="btn-contact w-100 text-center p-3" href="https://api.whatsapp.com/send?phone=+551151999219&text=Oi&source=&data=&app_absent=" target="_blank">
                            <strong [translate]="'FALAR_TIME_COMERCIAL'"></strong>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4 d-none d-lg-block">
            
        </div>
    </div>
    <div class="row login-footer bg-black position-absolute bottom-0 p-3 w-100 m-auto">
        <div class="col-sm-12 col-lg-6 text-center login-info-md" style="text-decoration: none;">
            Milvus © 2024 - <span [translate]="'COPYRIGHT'"></span>
        </div>
        <div class="col-sm-12 col-lg-3 my-lg-0 my-sm-3 text-center login-info-md">
            <a class="login-info-md" href="https://milvus.com.br/politica" target="_blank" [translate]="'POLITICA_PRIVACIDADE'">
            </a>
        </div>
        <div class="col-sm-12 col-lg-3 text-center login-info-md">
            <a class="login-info-md link-condicoes" href="https://milvus.com.br/termos" target="_blank" [translate]="'CONDICOES_DE_USO'">
            </a>
        </div>
    </div>
</div>

